import React from 'react';
import './Loading.css';

const Loading = () => (
  <div className="loading-container">
    <h2 className="loading">LOADING</h2>
  </div>
);

export default Loading;
